<template>
  <div class="home">
    <img
      alt="inoe logo"
      src="@/assets/inoe-logo/Logo_iNoe.svg"
      class="icon-logo"
    />
    <b-card
      bg-variant="white"
      text-variant="dark"
      class="
        w-100
        d-flex
        justify-content-center
        align-items-center
        authenticationStatus
      "
      :title="welcomeMsg"
    >
      <b-card-header header-bg-variant="dark" header-text-variant="white">
        <span>{{ `Connexion à ${accesskey}@${dossier}` }}</span>
      </b-card-header>
      <b-card-body>
        <h3>{{ authenticationStatus }}</h3>
        <b-spinner variant="danger" label="Spinning"></b-spinner>
      </b-card-body>
    </b-card>
    <div v-if="!isAuthenticationSuccess"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import store from "@/store";
import { mapGetters, mapState } from "vuex";

import $inoe from "@/config";

export default {
  name: "Session",
  props: {},
  components: {},

  data() {
    return {
      accesskey: "",
      dossier: "",
      welcomeMsg: this.$t("anmobi.home.msg_bienvenue"),
    };
  },
  mounted() {
    this.accesskey = $inoe.getAccessKey();
    this.dossier = $inoe.getDossier();
    store.dispatch("session/openSession");
  },
  computed: {
    ...mapGetters("session", ["getSession", "isAuthenticated"]),
    isAuthenticationSuccess() {
      return this.getSession.status == 200;
    },

    authenticationStatus() {
      let msg = [
        this.$t("anmobi.ouverture_session"),
        this.$t("anmobi.succes_ouverture_session"),
        this.$t("anmobi.echec_ouverture_session"),
        this.$t("anmobi.fermeture_de_session"),
        this.$t("anmobi.session_fermee"),
      ];
      return msg[this.getSession.status];
    },
    ...mapState(["importationState"]),
  },

  watch: {
    importationState(newval, oldval) {
      if (newval[0] !== -1 && newval[0] === newval[1])
        this.$router.push("/etablissements");
    },
    getSession: function (newVal, oldVal) {
      // watch it
      if (newVal.status === 200) {
        console.log("Prop changed: ", newVal, " | was: ", oldVal);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  background: rgb(37, 150, 136);
  background: linear-gradient(
    90deg,
    rgba(37, 150, 136, 1) 0%,
    rgba(52, 187, 210, 1) 50%,
    rgba(37, 150, 136, 1) 100%
  );
  height: 100vh;
  font-weight: bold;
  font-size: 1.2rem;
}
.icon-logo {
  max-width: 100px;
  margin: 2rem 0;
}
.authenticationStatus {
  padding: 1rem 0;
}
</style>
